<template>
	<div class="container mb-5">
		<div class="row" v-if="quiz === null">
			<div class="col-12 text-center">
				<i class="fa fa-spin fa-spinner fa-3x fa-fw text-muted mt-5"></i> 
				<!-- Lade Quiz <i>{{quizKey}}</i> -->
			</div>
		</div>
		<div class="row" v-else-if="quiz.failed">
			<div class="col-12 col-md-6 offset-md-3 mt-5 text-center">
				<b-alert :variant="'danger'" show>Laden des Quizzes fehlgeschlagen.</b-alert>
			</div>
		</div>
		<div class="row" v-else>
			<div class="col-12 mt-3">

				<h4 style="text-align: center;" class="pt-3">{{quiz.name}}</h4>

				<!-- <ul class="nav nav-pills justify-content-center hidden-xs-down" :class="{'nav-pills-left hidden-md-down': quiz.questions.length > 15}" role="tablist"> -->
				<ul class="list-inline nav-pills text-center" role="tablist">
					<!-- <ul class="nav nav-pills flex-column" role="tablist"> -->
					<li class="list-inline-item">
						<a class="nav-link" :class="[activeTab == -1 ? 'active' : '']" @click="openTab(-1)" href="#" id="startnav">
							Start
						</a>
					</li>

					<li class="list-inline-item" v-for="(question, key) in quiz.questions" :key="key + 'nav'" :id="key + 'nav'">
						<a class="nav-link" :class="{'active': activeTab == key}" @click="openTab(key)" href="#">

							<!-- <span v-if="quiz.questions.length < 10 || quiz.questions.length > 15">{{(key+1) + '. Frage'}}</span> -->
							<span v-if="quiz.questions.length < 10">{{(key+1) + '. Frage'}}</span>
							<span v-else>{{key+1}}</span> 
							<!-- <i :class="{'hidden': !question.answered}" class="fa fa-check fa-fw"></i> -->
							<i v-if="question.answered" class="fa fa-check fa-fw"></i>
						</a>
					</li>

					<li class="list-inline-item" v-if="quizSolved">
						<a class="nav-link" href="#" @click="openTab(quiz.questions.length)" :class="{'active': activeTab == quiz.questions.length}">Rangliste</a>
					</li>
				</ul>

				<!-- <div :class="{'hidden': progress == 0}" class="col-3 col-md-6 offset-md-3 mt-4"> -->
				<div class="col-12 col-md-6 offset-md-3 mt-3 mb-4">
					<b-progress :value="progress" :variant="'success'" style="height: 5px;"></b-progress>
				</div>
			</div>
			<div id="question-holder" class="col-12 col-lg-8 offset-lg-2">
				<transition name="fade" @before-leave="beforeLeave" @after-leave="afterLeave" @enter="enter">
					<!-- <transition name="fade" @before-enter="beforeEnter" @after-leave="afterLeave"> -->
					<!-- Start -->
					<div class="tab-pane active" v-if="activeTab==-1" :key="'starttab'" id="starttab">
						<b-card>
							<div class="row">
								<div class="col-12" v-html="nl2br(quiz.description)"></div>
								<div class="card-block">
									<!-- Koonys Quizzes Start -->
									<!-- <ins class="adsbygoogle"
									style="display:block"
									data-ad-client="ca-pub-8001728079841345"
									data-ad-slot="8970086511"
									data-ad-format="auto"></ins> -->

									<adsense 
									v-if="!local"
									ad-client="ca-pub-8001728079841345" 
									ad-slot="8970086511"
									ad-style="display: block"
									ad-format="auto"></adsense>
									<p v-else class="text-center text-muted">Werbung</p>
								</div>
								<div class="w-100"><hr></div>
								<div class="col text-center">
									<timer v-if="progress < 100" :time="quiz.startTime"></timer>
									<div v-else><i class="fa fa-clock-o fa-fw text-info"></i> {{quiz.endTime - quiz.startTime | makeDurationPretty}}</div>
								</div>
								<div class="col text-center"><i class="fa fa-check-circle-o fa-fw"></i> {{progress}}%</div>
								<div class="w-100 hidden-sm-up"><hr></div>
								<div class="col text-center">
									<b-button v-if="progress < 100" :size="'sm'" :variant="'link'" @click="startQuiz"><i v-if="quiz.restart" class="fa fa-spin fa-spinner fa-fw"></i> Neustart</b-button>
									<b-button v-else :size="'sm'" :variant="'warning'" @click="startQuiz"><i v-if="quiz.restart" class="fa fa-spin fa-spinner fa-fw"></i> erneut starten</b-button>
								</div>
								<!-- <div class="w-100"><hr></div> -->
							</div>
						</b-card>
						<div class="mt-3 row">
							<div class="col">
								<b-button @click="openTab(quiz.questions.length)" :size="'sm'" :variant="'primary'" v-if="quizSolved"><i class="fa fa-line-chart fa-fw"></i> Rangliste</b-button>
							</div>
							<div class="col">
								<b-button @click="nextTab" :size="'sm'" :variant="quizSolved ? 'secondary' : 'success'" class="pull-right">1. Frage&nbsp;<i class="fa fa-arrow-right"></i></b-button>
							</div>
						</div>
					</div>

					<!-- Questions -->
					<div class="tab-pane active" v-if="activeTab==key" v-for="(question, key) in quiz.questions" :key="key + 'tab'" :id="key + 'tab'">
						<div :is="'question-' + question.type" :question="question" :questionKey="key"></div>

						<div class="mt-3 row">
							<div class="col">
								<b-button @click="lastTab" :size="'sm'" v-if="activeTab > -1"><i class="fa fa-arrow-left"></i> {{ key == 0 ? 'Start' : key + '. Frage'}}</b-button>
							</div>
							<div class="col text-center">
								<b-button @click="openTab(quiz.questions.length)" :size="'sm'" :variant="'primary'" v-if="quizSolved"><i class="fa fa-line-chart fa-fw"></i> Rangliste</b-button>
							</div>
							<div class="col">
								<b-button @click="nextTab" :size="'sm'" :variant="question.answered ? 'success' : 'secondary'" v-if="activeTab < quiz.questions.length -1" class="pull-right">{{key+2}}. Frage <i class="fa fa-arrow-right"></i></b-button>
							</div>
						</div>
					</div>

					<!-- Rangliste -->
					<div v-if="quizSolved && activeTab == quiz.questions.length" class="tab-pane active">
						<b-card>
							<div>
								<b-button @click="lastTab" :size="'sm'"><i class="fa fa-arrow-left fa-fw"></i> {{quiz.questions.length}}. Frage</b-button>
								<b-button @click="openTab(-1)" :size="'sm'" class="pull-right">Start</b-button>
							</div>
							<h5 v-if="userRang.length > 0" class="text-center mt-5 mt-sm-0">Du hast den {{userRang[0].rang}}. Platz erreicht.</h5>
							<h6 v-else class="text-center text-muted mt-5 mt-sm-0">Keine Ranglisteneinträge von dir vorhanden.</h6>
							<div class="card-block">
								<!-- Koonys Quizzes
								<ins class="adsbygoogle"
								style="display:block"
								data-ad-client="ca-pub-8001728079841345"
								data-ad-slot="9735469318"
								data-ad-format="auto"></ins> -->

								<adsense 
								v-if="!local"
								ad-client="ca-pub-8001728079841345" 
								ad-slot="9735469318"
								ad-style="display: block"
								ad-format="auto"></adsense>
								<p v-else class="text-center text-muted">Werbung</p>
							</div>
							<!-- <h6 class="card-subtitle mb-2 text-muted text-center">{{userRang[0].rang}}. Platz</h6> -->
							<!-- <pre>{{userRang}}</pre> -->
							<div class="card-block mt-4">
								<transition-group name="hallOfFame" class="list-unstyled" tag="ul">
									<dl class="row" v-for="(fame, key) in hallOfFame" :key="fame">
										<dt class="col-sm-3"><span class="badge badge-pill badge-info">{{key+1}}.</span>&nbsp; {{fame.duration | makeDurationPretty}}<i class="fa fa-clock-o fa-fw"></i></dt>
										<dd v-if="fame.userid == $store.state.user.uid" class="col-sm-9">
											<mark @click="deleteFame(fame.key)">{{fame.username ? fame.username : 'Anonym'}}</mark>
										</dd>
										<dd v-else-if="fame.username" class="col-sm-9">
											{{fame.username}}
										</dd>
										<dd v-else class="col-sm-9">
											<span @click="deleteFame(fame.key)">Anonym</span>
										</dd>
									</dl>
								</transition-group>
							</div>
						</b-card>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import autosize from "autosize";
	// import math from "mathjs";
	
	const local = process.env.NODE_ENV == 'development'

	// console.log('ENV: ', env)

	export default {
		data(){
			return {
				quizKey: '-' + this.$route.params.key,
				name: this.$route.params.name,
				startTime: '',
				activeTab: -1,
				runInterval: null,
				local: local,
				transitionHeight: 0
			}
		},
		metaInfo(){
			return {
				title: this.quiz ? this.quiz.name : '...',
				titleTemplate: '%s Online Quiz | Koonys Schule',
				meta: [
				// {name: 'description', content: this.quiz ? this.quiz.description.replace(/<((?!>).)*>/g, '') : 'Super Quiz.'}
				{name: 'description', content: this.quiz ? this.quiz.questions.length + ' online Aufgaben über ' + this.quiz.name + '. Dein Wissen direkt online testen mit Koonys Schule.' : 'Super Quiz.'}
				]
			}
		},
		methods: {
			// beforeEnter: function(el){
			// 	// document.getElementById('footer').classList.add('fade')
			// 	document.getElementById('footer').style.display="none"
			// },

			// afterLeave: function(el){
			// 	// document.getElementById('footer').classList.remove('fade')
			// 	document.getElementById('footer').style.display="block"
			// },

			beforeLeave: function (el) {
				// console.log('beforeLeave', el)
				// console.log('Height: ', el.offsetHeight, el.clientHeight)

				this.transitionHeight = el.offsetHeight
				el.parentNode.style.height = el.offsetHeight + 'px'
			},
			enter: function (el) {
				// console.log('enter', el)

				if(this.transitionHeight < el.offsetHeight){
					// console.log('Change from ', el.parentNode.style.height, ' to ', el.offsetHeight + 'px')
					el.parentNode.style.height = el.offsetHeight + 'px'
				}
			},
			afterLeave: function(el){
				document.getElementById('question-holder').style.height = ""
				this.transitionHeight = 0
			},
			nextTab(){
				// window.scrollTo(0, 57)
				this.activeTab++
			},
			lastTab(){
				// window.scrollTo(0, 57)
				this.activeTab--
			},
			openTab(tab){
				this.activeTab = tab
			},
			startQuiz(){
				// console.log('Starte Quiz', this.quizKey)
				this.quiz.restart = true

				clearInterval(this.runInterval)
				this.$store.dispatch('startQuiz', this.quiz.key)
			},
			deleteFame(fameKey){
				// console.log('Dein Fame wird deleted.', fameKey)
				this.$store.dispatch('deleteFame', {fameKey: fameKey, quizKey: this.quiz.key})
			},
		},
		beforeCreate(){
			if(this.$route.params.key){
				this.$store.dispatch('loadQuiz', this.$route.params.key)
			}else if(this.$route.params.name){
				this.$store.dispatch('loadQuizByName', this.$route.params.name)
			}else{
				console.log('Quiz kann nicht geladen werden.')
			}
		},
		updated(){
			// console.log('Quiz.vue was updated.', this.quizKey, this.quiz)
			MathJax.Hub.Queue(["Typeset",MathJax.Hub]);

			if(this.quizSolved && !this.quiz.solved){
				// console.log('Solved', this.quiz)
				this.$store.commit('quizSolved')
			}
		},
		computed: {
			quiz(){
				this.$store.state.user && this.$store.state.user.isAdmin && console.log('Compute Quiz.', this.$store.state.quiz)
				// this.$store.state.user && this.$store.state.user.isAdmin && console.log('User:', this.$store.state.quiz)

				return this.$store.state.quiz
			},
			questionsSolved(){
				return  this.quiz.questions ? this.quiz.questions.reduce( (p, v) => p + v.answered, 0) : 0
			},
			quizSolved(){

				console.log('quizSolved', this.quizKey, this.quiz)
				return this.quiz && this.quiz.questions && this.questionsSolved == this.quiz.questions.length
			},
			progress(){
				console.log('progress()', this.quizKey, this.quiz)
				return this.quiz && Math.round(this.questionsSolved / this.quiz.questions.length * 100)
			},
			hallOfFame(){
				// console.log('Hall of Fame gefamed', this.quiz.hallOfFame)
				return this.quiz.hallOfFame.sort( (a, b) => a.duration - b.duration)
			},
			userRang(){
				return this.hallOfFame
				.map( (v, i) => v.userid == this.$store.state.user.uid ? {rang: i+1, time: v.time} : {rang: -1})
				.filter( v => v.rang > -1)
				.sort( (a, b) => b.time - a.time)
			}
		},
		filters: {
			makeDurationPretty: function(time){
				// console.log('Filter mit ' + time + ' ausgeführt.')

				time = time / 1000

				let seconds = Math.round( time % 60 )
				seconds = seconds < 10 ? '0' + seconds : seconds

				return Math.floor(time / 60) + ':' + seconds
			}
		},
		beforeDestroy(){
			// this.runInterval && clearInterval(this.runInterval)
			this.$store.commit('resetQuiz')
		}
	}
</script>

<style>
	/*.nav-pills-left{
		display: inline-block;
		position: absolute;
	}*/

	/*.nav>li>a {
		padding-top: 3px;
		padding-bottom: 3px;
	}*/

	.fade-enter{
		opacity: 0;
	}

	.fade-enter-active{
		transition: all .3s ease;
		position: absolute;

		/*position: relative;*/
		/*top: 0;*/

		left: 15px;
		right: 15px;
	}

	.fade-enter-to{
		opacity: 1;
	}

	.fade-leave{
		opacity: 1;
	}

	.fade-leave-active{
		transition: all .3s ease;
		position: absolute;

		/*position: relative;*/
		/*top: 0;*/

		left: 15px;
		right: 15px;
	}

	.fade-leave-to{
		opacity: 0;
	}

	.tab-pane.fade-enter-active + div{
		visibility: hidden;
	}


	/*
	* Hall Of Fame Transition
	*/
	.hallOfFame-enter, .hallOfFame-leave-to{
		opacity: 0;
		transform: translateX(50px);
	}

	.hallOfFame-enter-active, .hallOfFame-leave-active{
		transition: all .66s ease;
		/*position: absolute;*/

	}

	/*.hallOfFame-leave-active{
		position: absolute;;
	}
	*/
	.hallOfFame-enter-to, .hallOfFame-leave{
		opacity: 1;
	}

	/*.hallOfFame-move{
		transition: transform 6s;
	}*/
</style>


// WEBPACK FOOTER //
// Quiz.vue?7ec6c17c